import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORKS]: {
		url:'/company/:companyId/done_works/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK]: {
		url: '/company/:companyId/done_works/:doneWorkId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS].CREATE_DONE_WORK]: {
		url:'/company/:companyId/done_works/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS].PATCH_DONE_WORK]: {
		url: '/company/:companyId/done_works/:doneWorkId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS].PUT_DONE_WORK]: {
		url: '/company/:companyId/done_works/:doneWorkId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS].DELETE_DONE_WORK]: {
		url: '/company/:companyId/done_works/:doneWorkId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}